import React from 'react'
import { dispatch } from '@rematch/core';
import { Form } from 'formsy-semantic-ui-react';
import { Button, Header, Modal, Grid, Divider, List, Image, Feed } from 'semantic-ui-react'
import Labels from '../../../../common/Labels'
import momentDate from '../../../../../helpers/momentDate';
import ImageAvater from '../../../../drive/Components/ImageAvater';
import EllipsisTooltip from '../../../../common/EllipsisTooltip';
import MomentTime from '../../../../common/MomentTime';
import defaultLogo from "../../../../../images/logo/logo-128.png";
import TextEditor from '../../../../common/TextEditor';

class ReactivateAccountModal extends React.PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			reason: ''
		};
	}


	handleClose = () => {
		this.setState({ reason: '' });
		this.props.closeReactivateAccountModal(false)
	}

	async reActivateAccount(formData) {
		let payload = {
			accountId: this.props.account._id,
			subscriptionId: this.props.account.subscriptionId,
			reason: this.state.reason
		}
		await dispatch.account.reactivateAccount(payload);
		this.handleClose()
	}

	updateText = (data, name) => {
		if (name === "Reason") {
			if (data.replace(/<(.|\n)*?>/g, '').trim().length === 0) {
				this.setState({ reason: '' })
			} else {
				this.setState({ reason: data })
			}
		}
	}

	render() {
		const errorLabel = <div style={{ margin: '5px 0px 0px 0px' }} className="customErrorLabel" />;
		let account = this.props.account;
		let user = this.props.user && this.props.user.accounts.filter((account) => {
			return account.name === "Aspenify Platform"
		})[0];

		let userRole = ''
		if (user) {
			userRole = user.role === 'platformAdmin' ? 'Platform Admin' : ''
		}
		return (
			<Modal
				open={this.props.isReactivateAccountModalOpen}
				onClose={this.handleClose}
				size='tiny'
				className="basicModal"
				closeOnEscape={true}
				closeOnDimmerClick={false}
				closeIcon
			>
				<Header style={{ margin: '0px 0px 10px 0' }} content={"Reactivate account"} ></Header>
				<Form noValidate
					ref={ref => this.form = ref}
					id="reactivateAccount"
					preventExternalInvalidation={true}
					onValidSubmit={(event) => { this.reActivateAccount(event) }}
					className="formcyForm"
				>
					<Modal.Content>
						<Grid>
							<Grid.Row className=' bg-clr-lightBlue' style={{ margin: "0 15px", paddingBottom: '0px' }}>
								<Grid.Column width={8}>
									<Labels
										text={<div >
											<div className="accountLogoTiny" >
												<Image className="mar_0" src={account && account.logo ? account.logo : defaultLogo} />
											</div>
											<div className='float-left mar_5' >
												<EllipsisTooltip style={{ color: '#333' }} name={account && account.name} />
											</div>
										</div>}
									/>
								</Grid.Column>
								<Grid.Column width={8}>
									<Labels
										text={<List horizontal >
											<List.Item>
												<ImageAvater user={account && account.ownerId} imageStyle="f_10 w_32 h_32 mar_0" />
												<div className="float-left f_12 pad_2 " >
													<EllipsisTooltip
														name={account && account.ownerId.firstName + ' ' + account.ownerId.lastName}
														line={2}
														style={{ 'lineHeight': '14px', padding: '0px 0px 2px 0px', color: '#333' }}
													/>
													<span className="float-left f_10 pad_2 clr-dark-gray "><EllipsisTooltip
														name={account && account.ownerId.email}
														line={2}
														style={{ 'lineHeight': '14px', color: '#333' }}
													/></span>
												</div>
											</List.Item>
										</List>}
									/>
								</Grid.Column>
							</Grid.Row>
							<Divider style={{ margin: '5px 0' }} />
							<Grid.Row className=' bg-clr-lightBlue' style={{ margin: "0 15px", paddingBottom: '0px' }}>
								<Grid.Column>
									<Feed className={`reactivateModal bg-light-blue`} >
										<Feed.Event>
											<ImageAvater user={this.props.lastDeactivationLog && this.props.lastDeactivationLog.by} />
											<Feed.Content>
												<Feed.Summary>
													{this.props.lastDeactivationLog && this.props.lastDeactivationLog.by && this.props.lastDeactivationLog.by.firstName + ' ' + this.props.lastDeactivationLog.by.lastName}
													<span className="clr-red">  deactivated account </span>
													<span className="pull-right">{momentDate(this.props.lastDeactivationLog && this.props.lastDeactivationLog.date)}  </span>
												</Feed.Summary>
												<Feed.Date>
													<span style={{ lineHeight: '1.5em' }}>{userRole}</span>
													<span className="pull-right" style={{ textAlign: "right", paddingTop: '3px' }}>
														<MomentTime date={this.props.lastDeactivationLog && this.props.lastDeactivationLog.date} />
													</span></Feed.Date>
											</Feed.Content>
										</Feed.Event>
										<Divider className="mar_0" />
										<div>
											<Labels
												name="Reason"
												text={this.props.lastDeactivationLog && this.props.lastDeactivationLog.reason}
												htmlView={true} />
										</div>
									</Feed>
								</Grid.Column>
							</Grid.Row>

							<Grid.Row className="pad_0">
								<Grid.Column width={16}>
									<br />
									<TextEditor

										name="Reason"
										text={this.state.reason}
										type="textarea"
										onChangeText={this.updateText}
										requiredValue={true}
									/>
								</Grid.Column>
							</Grid.Row>
							<Grid.Row style={{ paddingTop: '5px' }}>
								<Grid.Column width={16}>
									Are you sure you want to reactivate this account?
								</Grid.Column>
							</Grid.Row>
						</Grid>
					</Modal.Content>
					<Divider />

					<Modal.Actions className="actionInFormcy">

						<Button
							className="button-submit float-right"
							formNoValidate={true}
							id='deactivateBtn'
							disabled={this.state.reason.length === 0}
							type="submit"> Reactivate </Button>
						<Button id='cancelBtn'
							className="button-cancel"
							onClick={this.handleClose}
							type="button">
							Cancel </Button>
					</Modal.Actions>

				</Form>
			</Modal>
		)
	}
}

export default ReactivateAccountModal